module.exports = "<button class=\"deleteButton\" (click)=\"openDialog()\" mat-icon-button>\r\n   <mat-icon aria-label=\"edit skills\">close</mat-icon>\r\n</button>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/profile/delete-form/delete-form.dialog.html
// module id = ../../../../../src/app/profile/delete-form/delete-form.dialog.html
// module chunks = main